import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { distance } from "framer-motion";

// const baseURL = "http://localhost:3011";
const baseURL = "https://atci.lkm.vodafoneacademy.accenture.com/vodafone-apis";

export const UploadCoursesSlice = createSlice({
    name: "CoursesList",
    initialState: {
        CoursesUploadData: [],
        uploading: false,
        success: false,
        errorMsg: false,
        statusText: '',
    },
    reducers: {
        setError: (state) =>{
            state.error = true;
        },
        setCoursesUploadData: (state, {payload}) =>{
            state.error = false;
            state.CoursesUploadData = payload;
        },
        setUploadRequest: (state) => {
          state.uploading = true;
          state.success = false;
          state.errorMsg  = false;
        },
        setsuccessMessage: (state, action) =>{
          state.uploading = false;
          state.errorMsg = false;
          state.success = true;
          state.statusText = action.payload
      },
      seterrorMessage: (state, action) =>{
        // state.error = false;
        state.uploading = false;
        state.errorMsg = true;
        state.statusText = action.payload

    }
    }
})
export const {setError, setCoursesUploadData, setsuccessMessage, seterrorMessage, setUploadRequest} = 
UploadCoursesSlice.actions;

export default UploadCoursesSlice.reducer;
let selectedCourse;
let selectedLevel;
export function uploadCourses(formData, properties) {
  // console.log(properties)
   selectedCourse = properties.selectedCourse;
   selectedLevel = properties.selectedLevel
  return async (dispatch) => {
    dispatch(setUploadRequest());
    try {
      formData.append('properties', JSON.stringify(properties));
      const response = await axios.post(`${baseURL}/UploadCourses/${properties.selectedCourse}_${properties.selectedLevel}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
          // 'Authorization': localStorage.getItem("token"),
        }
      });
      dispatch(setsuccessMessage('File uploaded successfully!'));
      console.log('File uploaded successfully:', response);
    } catch (error) {
      dispatch(setError(error))
      dispatch(seterrorMessage('Error in uploading file!'));
      console.error('Error uploading file:', error);
    }}}

    export function Coursesdata(){
      const tableNames = ["Web_Developer_Beginner", "Web_Developer_Intermediate", "Web_Developer_Advanced",
      "System_Engineer_Beginner", "System_Engineer_Intermediate", "System_Engineer_Advanced",
      "FullStack_Engineer_Beginner", "FullStack_Engineer_Intermediate", "FullStack_Engineer_Advanced",
      "Automation_Engineer_Beginner", "Automation_Engineer_Intermediate", "Automation_Engineer_Advanced",
      "Backend_Developer_Beginner", "Backend_Developer_Intermediate", "Backend_Developer_Advanced"
    ]
  return (dispatch) => {
  axios.get(`${baseURL}/fileData/${tableNames.map((item)=>item)}`, {
    headers: {
      Authorization: localStorage.getItem("token"),
      "Content-Type": "application/json",
    },
  })
  .then((res) =>{
    dispatch(setCoursesUploadData(res.data))
  console.log('courses data ',res.data)
  console.log('course', selectedCourse)

  })
  .catch((err)=>{
    dispatch(setError(err))
    console.error("error is", err);
  })
}}    